import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

export const ModalText = ({ children }: Props) => {
  return <p className='mb-4 mt-2'>{children}</p>;
};
